<!-- admin-dashboard.component.html -->
<div class="container mx-auto p-8">
  <h1 class="text-3xl font-bold mb-8 mt-24">Panel de Administración</h1>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <!-- Gestión de Paquetes -->
    <div class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" routerLink="/admin/package-management">
      <div class="flex items-center mb-4">
        <i class="fas fa-boxes text-3xl text-blue-500 mr-4"></i>
        <h2 class="text-xl font-semibold">Gestión de Paquetes</h2>
      </div>
      <p class="text-gray-600">Gestiona empaquetado, envío y carga de repuestos al transporte</p>
    </div>


    <!-- Administración de Carpetas -->
    <div class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" routerLink="/admin/exported-folders">
      <div class="flex items-center mb-4">
        <i class="fas fa-folder-open text-3xl text-green-500 mr-4"></i>
        <h2 class="text-xl font-semibold">Carpetas Exportadas</h2>
      </div>
      <p class="text-gray-600">Gestiona y accede a las carpetas de exportación generadas</p>
    </div>

    <!-- Gestión de Talleres -->
    <div class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" routerLink="/admin/workshops">
      <div class="flex items-center mb-4">
        <i class="fas fa-tools text-3xl text-orange-500 mr-4"></i>
        <h2 class="text-xl font-semibold">Gestión de Talleres</h2>
      </div>
      <p class="text-gray-600">Administra talleres y genera etiquetas PDF</p>
    </div>

    <!-- Historial de Acciones -->
    <div class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" routerLink="/admin/action-history">
      <div class="flex items-center mb-4">
        <i class="fas fa-history text-3xl text-purple-500 mr-4"></i>
        <h2 class="text-xl font-semibold">Historial de Acciones</h2>
      </div>
      <p class="text-gray-600">Consulta el registro detallado de todas las acciones realizadas</p>
    </div>

    <!-- KPIs de Empaquetado -->
    <div *ngIf="canAccessKpi" class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" routerLink="/admin/packaging-kpi">
      <div class="flex items-center mb-4">
        <i class="fas fa-chart-line text-3xl text-indigo-500 mr-4"></i>
        <h2 class="text-xl font-semibold">KPIs de Empaquetado</h2>
      </div>
      <p class="text-gray-600">Métricas de desempeño por usuario en eventos de empaquetado</p>
    </div>
  </div>
</div> 